module.exports = require("react-bootstrap");


//////////////////
// WEBPACK FOOTER
// external "react-bootstrap"
// module id = 3
// module chunks = 0 1 2